document.addEventListener('DOMContentLoaded', function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* The card carries one visual per accordion row, and every start state lives
     on the *inactive* visual — so activating is what plays it.

     Two things that has to get right:

     - The first play waits for the card to be in view. Activating at
       DOMContentLoaded ran the whole animation off screen, and by the time the
       section was scrolled to it had already finished.
     - Re-opening a row whose visual is already showing must still replay. A
       plain class toggle is a no-op there, so the rewind is explicit. */
  function initVisuals(section) {
    var card = section.querySelector('.sych-sci__card');
    var visuals = Array.prototype.slice.call(section.querySelectorAll('[data-sci-viz]'));
    if (!card || !visuals.length) return null;

    /* Tells the CSS the script is here, so the chart stops being the
       unconditional no-JS fallback. */
    card.classList.add('is-swappable');

    var wanted = 'chart';
    var showing = null;
    var revealed = false;

    function find(name) {
      var hit = null;
      visuals.forEach(function (viz) {
        if (viz.dataset.sciViz === name) hit = viz;
      });
      return hit;
    }

    function play() {
      var target = find(wanted) || find('chart') || visuals[0];
      if (!target) return;
      showing = target.dataset.sciViz;

      /* Rewind with transitions suppressed. Just removing .is-active would send
         every bar travelling back to zero over its own full duration, so
         re-adding it in the same breath would leave nothing left to travel and
         the whole thing would look static. */
      target.classList.add('is-resetting');
      target.classList.remove('is-active');
      void card.offsetWidth;

      target.classList.remove('is-resetting');
      void card.offsetWidth;

      visuals.forEach(function (viz) {
        viz.classList.toggle('is-active', viz === target);
      });
    }

    return {
      /* Records which visual belongs to the open row and plays it — but only
         when that is a different visual from the one already on screen. Opening
         a third row that shares the second row's chart is not a fresh reveal, so
         re-running it there would read as a stutter rather than a transition. */
      select: function (name) {
        var next = name || 'chart';
        if (!find(next)) next = 'chart';
        wanted = next;

        if (!revealed) return;
        if (showing === wanted) return;

        play();
      },
      /* Called once, when the card first comes into view. */
      reveal: function () {
        if (revealed) return;
        revealed = true;
        play();
      }
    };
  }

  function initAccordion(section, visuals) {
    var items = section.querySelectorAll('.sych-sci__item');

    function close(item) {
      var panel = item.querySelector('.sych-sci__body');
      var trigger = item.querySelector('.sych-sci__trigger');
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () {
        panel.style.height = '0px';
      });
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function open(item) {
      var panel = item.querySelector('.sych-sci__body');
      var trigger = item.querySelector('.sych-sci__trigger');
      panel.style.height = panel.scrollHeight + 'px';
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.addEventListener('transitionend', function onEnd() {
        if (item.classList.contains('is-open')) {
          panel.style.height = 'auto';
        }
        panel.removeEventListener('transitionend', onEnd);
      });
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('.sych-sci__trigger');
      var panel = item.querySelector('.sych-sci__body');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        if (item.classList.contains('is-open')) {
          close(item);
          return;
        }
        items.forEach(function (other) {
          if (other !== item && other.classList.contains('is-open')) close(other);
        });
        open(item);
        if (visuals) visuals.select(item.dataset.sciVisual);
      });
    });

    /* Whichever row rendered open decides what the card shows on arrival — but
       it only plays once the card is actually in view. */
    if (visuals) {
      var openItem = section.querySelector('.sych-sci__item.is-open');
      visuals.select(openItem ? openItem.dataset.sciVisual : 'chart');
    }
  }

  /* Left card entrance. The start state rides in on .is-anim from the markup —
     adding that class here instead would transition the card backwards into
     hiding before it played forward. All this does is decide when to release it. */
  function initCard(section, visuals) {
    var card = section.querySelector('.sych-sci__card');
    if (!card) return;

    if (REDUCED || (window.Shopify && window.Shopify.designMode)) {
      card.classList.add('is-static', 'is-inview');
      if (visuals) visuals.reveal();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          /* next frame, so the start state is guaranteed to have painted and the
             transition actually runs when the card is already in view on load */
          requestAnimationFrame(function () {
            entry.target.classList.add('is-inview');
            /* The card visual's first play is tied to the same moment as the
               card's own entrance, rather than to page load. */
            if (visuals) visuals.reveal();
          });
        });
      },
      { threshold: 0.25, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(card);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-sych-sci]').forEach(function (section) {
      if (section.dataset.sciInit) return;
      section.dataset.sciInit = 'true';
      var visuals = initVisuals(section);
      initAccordion(section, visuals);
      initCard(section, visuals);
    });
  }

  init(document);

  /* the editor swaps the whole section in, so the replacement needs binding too */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
});
